import { render, staticRenderFns } from "./addPhone.vue?vue&type=template&id=8d32b76c&scoped=true"
import script from "./addPhone.vue?vue&type=script&lang=js"
export * from "./addPhone.vue?vue&type=script&lang=js"
import style0 from "./addPhone.vue?vue&type=style&index=0&id=8d32b76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d32b76c",
  null
  
)

export default component.exports